import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensFreeServicesSummaries} from './citizens-free-services-summaries.model';

export const loadCitizensFreeServicesSummariess = createAction(
  '[CitizensFreeServicesSummaries/API] Load CitizensFreeServicesSummariess',
  props<{ citizensFreeServicesSummariess: CitizensFreeServicesSummaries[] }>()
);

export const addCitizensFreeServicesSummaries = createAction(
  '[CitizensFreeServicesSummaries/API] Add CitizensFreeServicesSummaries',
  props<{ citizensFreeServicesSummaries: CitizensFreeServicesSummaries }>()
);

export const upsertCitizensFreeServicesSummaries = createAction(
  '[CitizensFreeServicesSummaries/API] Upsert CitizensFreeServicesSummaries',
  props<{ citizensFreeServicesSummaries: CitizensFreeServicesSummaries }>()
);

export const addCitizensFreeServicesSummariess = createAction(
  '[CitizensFreeServicesSummaries/API] Add CitizensFreeServicesSummariess',
  props<{ citizensFreeServicesSummariess: CitizensFreeServicesSummaries[] }>()
);

export const upsertCitizensFreeServicesSummariess = createAction(
  '[CitizensFreeServicesSummaries/API] Upsert CitizensFreeServicesSummariess',
  props<{ citizensFreeServicesSummariess: CitizensFreeServicesSummaries[] }>()
);

export const updateCitizensFreeServicesSummaries = createAction(
  '[CitizensFreeServicesSummaries/API] Update CitizensFreeServicesSummaries',
  props<{ citizensFreeServicesSummaries: Update<CitizensFreeServicesSummaries> }>()
);

export const updateCitizensFreeServicesSummariess = createAction(
  '[CitizensFreeServicesSummaries/API] Update CitizensFreeServicesSummariess',
  props<{ citizensFreeServicesSummariess: Update<CitizensFreeServicesSummaries>[] }>()
);

export const deleteCitizensFreeServicesSummaries = createAction(
  '[CitizensFreeServicesSummaries/API] Delete CitizensFreeServicesSummaries',
  props<{ id: string }>()
);

export const deleteCitizensFreeServicesSummariess = createAction(
  '[CitizensFreeServicesSummaries/API] Delete CitizensFreeServicesSummariess',
  props<{ ids: string[] }>()
);

export const clearCitizensFreeServicesSummariess = createAction(
  '[CitizensFreeServicesSummaries/API] Clear CitizensFreeServicesSummariess'
);


//CUSTOM

export const citizenGetFreeServicesSummaries = createAction(
  '[CitizensFreeServicesSummaries/API] citizen Get Free Services Summaries'
);

